module.exports = __webpack_public_path__ + "img/ac_level_1.046bcca8.png";